<template>
  <div
    v-if="alertCodes.length"
    class="flsa-report-preview-alerts d-flex flex-column ga-4"
  >
    <FlsaReportPreviewAlertItem
      v-for="code in alertCodes"
      :key="code"
      :alert-code="code"
      :latest-federal-submission="latestFederalSubmission"
      :forms="forms"
      :job-profile-ulid="jobProfileUlid"
      :draft-job-profile-ulid="draftJobProfileUlid"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import {
  getFederalAlertCodes,
  sortFlsaAlertCodes,
} from '@/components/library/flsaSurveys/alertHelpers';
import FlsaReportPreviewAlertItem from './FlsaReportPreviewAlertItem.vue';

const props = defineProps({
  reportItem: {
    type: Object,
    default: null,
  },
  latestFederalSubmission: {
    type: Object,
    default: null,
  },
  forms: {
    type: Array,
    default: () => [],
  },
  jobProfileUlid: {
    type: String,
    default: null,
  },
  draftJobProfileUlid: {
    type: String,
    default: null,
  },
});

const alertCodes = computed(() => sortFlsaAlertCodes(getFederalAlertCodes(props.reportItem)));
</script>
